export default {"src":"/_next/static/media/arrow-right.c4636986.svg","height":22,"width":12,"blurWidth":0,"blurHeight":0};